import styled from 'styled-components';
import { mq } from '~/styles/grid';
import Picture from '../../../atoms/Picture';
import getImageProperties from '~/helpers/getImageProperties';

export const teaserTileImgHeightMap = {
  LARGE: 278,
  MEDIUM: 205,
  SMALL: 221,
};

const ImageWrapper = styled.div`
  width: 100%;
  height: ${(props) => props.height}px;
  overflow: hidden;

  @media (${mq.smDown}) {
    height: 164px;
  }

  @media (${mq.xs}) {
    height: ${teaserTileImgHeightMap.SMALL}px;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

/**
 * @param {TeaserTileImageProps} props
 * @returns {React.ReactElement} The rendered component
 */
const TeaserTileImage = ({ image, type }) => {
  const imgHeight = teaserTileImgHeightMap[type];

  return (
    <ImageWrapper height={imgHeight} data-id="teaser-tile-image-wrapper">
      <Picture
        urls={getImageProperties(
          { xl: image.url, md: image.url, xs: image.url },
          'teaserTile',
        )}
        alt={image.alt}
        title={image.title}
      />
    </ImageWrapper>
  );
};

export default TeaserTileImage;
